import dayjs from 'dayjs';
import Badges from 'modules/common/components/Badge';
import { useShowSubscriber } from 'modules/for-verification/hooks';
import Pagination from 'partial/components/Pagination';
import Table from 'partial/components/Table';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useOrgMessageList } from '../hooks';

function Messages() {
  const { id } = useParams();
  const [, subscriber] = useShowSubscriber(id);
  const orgUuid = subscriber?.organization?.uuid;
  const [filter, setFilter] = useState({ page: 1 });
  const [isLoading, list, meta] = useOrgMessageList(filter, orgUuid);

  const format = [
    {
      label: 'date',
      id: 'date',
      key: (item) => (
        <span>{dayjs(item?.created_at).format('MMM DD, YYYY hh:mm A')}</span>
      ),
    },
    {
      label: 'recipient',
      id: 'recipient',
      key: 'recipient',
    },
    { label: 'mask name', id: 'mask-name', key: 'mask_name' },
    {
      label: 'message',
      id: 'message',
      key: (data) => (
        <div className="max-w-[200px] truncate">{data?.content}</div>
      ),
    },
    { label: 'request ip', id: 'request-ip', key: 'request_ip' },
    { label: 'sms count', id: 'sms-count', key: 'sms_count' },
    { label: 'sms length', id: 'sms-length', key: 'content_length' },
    {
      id: 'status',
      label: 'status',
      key: (data) => <Badges status={data?.status} />,
    },
  ]?.map((item) => {
    if (item?.id === 'status') {
      return {
        ...item,
        labelClassName: 'justify-end',
        contentClassName: 'flex justify-end',
      };
    }

    if (item?.id === 'sms-count' || item?.id === 'sms-length') {
      return {
        ...item,
        labelClassName: 'whitespace-nowrap',
        contentClassName: 'text-center',
      };
    }

    return {
      ...item,
      labelClassName: 'whitespace-nowrap',
      contentClassName: 'whitespace-nowrap',
    };
  });

  return (
    <div className="h-full flex flex-col space-y-10 justify-between">
      <Table isLoading={isLoading} data={list} format={format} />
      <div className="px-3">
        <Pagination value={meta} onChange={setFilter} />
      </div>
    </div>
  );
}

export default Messages;
